import { TEXTFIELD_TYPES_TO_PREVENT_CUSTOM_ADORNMENTS, TEXTFIELD_SIZE, TEXTFIELD_VARIANT } from './TextField.constants.js';

var getBorderRadius = function getBorderRadius(size, borderRadius) {
  return size === TEXTFIELD_SIZE.TINY ? 'none' : borderRadius.primary;
};
var getSize = function getSize(theme, size) {
  var REGULAR_SIZE_VALUE = theme.sizing.xlarge;
  switch (size) {
    case TEXTFIELD_SIZE.TINY:
      return theme.sizing.medium;
    case TEXTFIELD_SIZE.SMALL:
      return theme.sizing.large;
    case TEXTFIELD_SIZE.REGULAR:
      return REGULAR_SIZE_VALUE;
    default:
      return REGULAR_SIZE_VALUE;
  }
};
var getTypography = function getTypography(size, typography) {
  return size === TEXTFIELD_SIZE.REGULAR ? typography.bodyRegular : typography.bodyMedium;
};
var getVariantPalette = function getVariantPalette(_ref) {
  var theme = _ref.theme,
    $variant = _ref.$variant;
  switch ($variant) {
    case TEXTFIELD_VARIANT.SECONDARY:
      return theme.colours.canvas.primary;
    case TEXTFIELD_VARIANT.PRIMARY:
    default:
      return theme.colours.canvas.secondary;
  }
};
var getBgColour = function getBgColour(props) {
  var palette = getVariantPalette(props);
  return palette.main;
};
var getFocusBgColour = function getFocusBgColour(props) {
  var palette = getVariantPalette(props);
  return palette.weak;
};
var getHoverBgColour = function getHoverBgColour(props) {
  var palette = getVariantPalette(props);
  return palette.strong;
};
var shouldPreventAdornment = function shouldPreventAdornment(type) {
  return TEXTFIELD_TYPES_TO_PREVENT_CUSTOM_ADORNMENTS.includes(type);
};

export { getBgColour, getBorderRadius, getFocusBgColour, getHoverBgColour, getSize, getTypography, getVariantPalette, shouldPreventAdornment };
//# sourceMappingURL=TextField.utils.js.map
